module.exports = function (data,type, indicator, time_periods, tObj){
    const {T1, T2, T3} = tObj;
    // console.log('indicator', indicator);
    // console.log("cleandata T1", T1)
    // console.log("cleandata T2", T2)
    // if(T3){
    //     console.log("cleandata T3", T3);
    // }

    // console.log("time_periods", time_periods);
    // console.log("type", type);

    // risk will always only contain a single time period
    var risk_time = type == 'risk' ? `T${time_periods[0]}` : '';

    // this is necessary because some two time period surveys are T1 & T2 while others are T2 & T3
    var t_1 = `T${time_periods[0]}`,
        t_2 = `T${time_periods[1]}`,
        t_3;

    if(time_periods.length == 3){
        t_3 = `T${time_periods[2]}`;
    }

    var columns_to_keep = {},
        keys_to_keep = [],
        number_columns = [];

    if(type == "change"){
        columns_to_keep = {"CatCondPL":"Condition",
                            [`Sig.P.${t_2}-${t_1}.Cond`]:`Statistically Significant Change from ${T1} to ${T2} (95% Confidence Level)`,
                            [`Est.P.${t_1}.Cond`] : `${T1} Estimate`,
                            [`LCB.P.${t_1}.Cond`]: `${T1} Lower Confidence Bound`,
                            [`UCB.P.${t_1}.Cond`]: `${T1} Upper Confidence Bound`,
                            [`Est.P.${t_2}.Cond`] : `${T2} Estimate`,
                            [`LCB.P.${t_2}.Cond`] : `${T2} Lower Confidence Bound`,
                            [`UCB.P.${t_2}.Cond`] : `${T2} Upper Confidence Bound`};
      if(time_periods.length == 3){
            columns_to_keep[`Sig.P.${t_3}-${t_2}.Cond`] = `Statistically Significant Change from ${T2} to ${T3} (95% Confidence Level)`,
            columns_to_keep[`Est.P.${t_3}.Cond`] = `${T3} Estimate`;
            columns_to_keep[`LCB.P.${t_3}.Cond`] = `${T3} Lower Confidence Bound`;
            columns_to_keep[`UCB.P.${t_3}.Cond`] = `${T3} Upper Confidence Bound`;          
            }
        
        
        keys_to_keep = Object.keys(columns_to_keep);
        number_columns = keys_to_keep.filter(value => {
                                return (value != 'CatCondPL' && 
                                        value != 'Sig.P.T3-T2.Cond') && 
                                        value != 'Sig.P.T2-T1.Cond';});
                    
    }else if(type == "condition"){
        latest_time_period = t_3 ? t_3 : t_2;
        columns_to_keep = {"CatCondPL" : "Condition",
                            [`Est.P.${latest_time_period}.Cond`] : `Estimate`,
                            [`LCB.P.${latest_time_period}.Cond`] : `Lower Confidence Bound`,
                            [`UCB.P.${latest_time_period}.Cond`] : `Upper Confidence Bound`};
        
        keys_to_keep = Object.keys(columns_to_keep);
        // console.log(keys_to_keep)
        number_columns = keys_to_keep.filter(value => {
                            return (value != 'CatCondPL');});
                    
    }else if(type == "risk"){
        // There is a space after "Stressor " so that it does not get deleted and can be found in export_data.js
       columns_to_keep = {'StressorPL':'Stressor ',
                        [`Est.P.${risk_time}.AttRisk`]: `Estimated Attributable Risk to ` + indicator,
                        [`LCB.P.${risk_time}.AttRisk`]: `Lower Confidence Bound`,
                        [`UCB.P.${risk_time}.AttRisk`]: `Upper Confidence Bound`};
        keys_to_keep = Object.keys(columns_to_keep);
        number_columns = keys_to_keep.filter(value => {
            return (value != 'StressorPL');
        });


    }

    // filter and rename the columns
    for(var i=0; i<data.length; i++){
        export_keys = Object.keys(data[i]);
            for(var item in export_keys){
                curr_key = export_keys[item];
                if(!keys_to_keep.includes(curr_key)){
                    delete data[i][curr_key];
                }else{
                    // console.log('curr_key', curr_key);
                    data[i][columns_to_keep[curr_key]] = data[i][curr_key];
                    // console.log('data[i][columns_to_keep[curr_key]]', data[i][columns_to_keep[curr_key]]);
                    delete data[i][curr_key];
                }
            }  
        }
    //convert columns to number & round them
    for(var j=0; j<data.length; j++){
        for(var unit in keys_to_keep){
            old_column_name = keys_to_keep[unit];
            new_column_name = columns_to_keep[keys_to_keep[unit]];
            if(number_columns.includes(old_column_name)){
                var value = data[j][new_column_name];
                if(value > 0 && value < 0.5){
                    data[j][new_column_name] = "<1%";
                }else if(value !="NA" && Number(value) > 0.5){
                    data[j][new_column_name] = Number.parseFloat(value).toFixed(0)+"%";
                }else if(Number(value) == 0){
                    data[j][new_column_name] = "0%";
                }
            }
        }
    }

    return data;
};
